import { render, staticRenderFns } from "./SponsoringCheckboxBat.vue?vue&type=template&id=1e05a65b&scoped=true&"
import script from "./SponsoringCheckboxBat.vue?vue&type=script&lang=ts&"
export * from "./SponsoringCheckboxBat.vue?vue&type=script&lang=ts&"
import style0 from "./SponsoringCheckboxBat.vue?vue&type=style&index=0&id=1e05a65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05a65b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e05a65b')) {
      api.createRecord('1e05a65b', component.options)
    } else {
      api.reload('1e05a65b', component.options)
    }
    module.hot.accept("./SponsoringCheckboxBat.vue?vue&type=template&id=1e05a65b&scoped=true&", function () {
      api.rerender('1e05a65b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign/SponsoringCheckboxBat.vue"
export default component.exports